import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MediaModel } from '../../../helpers/objects/dto/media/media-model';
import { MediaRequestModel } from '../../../helpers/objects/request/media/media-request-model';
import { MediaResponseModel } from '../../../helpers/objects/response/media/media-response-model';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BackofficeCampaignsService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(private http: HttpClient, @Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel) {
    this.appConfig = appConfigTemp;
  }

  get(filter: MediaRequestModel): Observable<MediaResponseModel> {
    const httpParams: HttpParams = new HttpParams({
      fromObject: filter as any
    });
    return this.http
      .get<any>(this.appConfig.api + 'backoffice/medias/' + this.appConfig.apiPartnershipId, {
        params: httpParams
      })
      .pipe(map((response) => response.body as MediaResponseModel));
  }

  getDetails(mediaId: string): Observable<MediaModel> {
    return this.http.get<any>(this.appConfig.api + 'backoffice/medias/' + this.appConfig.apiPartnershipId + '/' + encodeURIComponent(mediaId)).pipe(
      map((response) => {
        return response.body as MediaModel;
      })
    );
  }

  edit(MediaFile: any): Observable<any> {
    return this.http.put(this.appConfig.api + 'backoffice/medias/' + this.appConfig.apiPartnershipId, MediaFile).pipe(map((response) => {}));
  }

  create(mediaFile: any): Observable<any> {
    return this.http.post(this.appConfig.api + 'backoffice/medias/' + this.appConfig.apiPartnershipId, mediaFile);
  }

  setup(featureName: string): Observable<any> {
    const params = new HttpParams({
      fromObject: {
        FeatureName: featureName ? featureName : ''
      }
    });
    return this.http.get<any>(this.appConfig.api + 'backoffice/setup/medias/' + this.appConfig.apiPartnershipId, { params }).pipe(
      map((response) => {
        return response.body;
      })
    );
  }
}
